module.exports = __webpack_public_path__ + "static/media/18.9d608857.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sports/svg/18.svg
// module id = 130
// module chunks = 0